import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from "react";

var SearchInfoListItem = function SearchInfoListItem(_ref) {
  var value = _ref.value,
      className = _ref.className,
      candidate = _ref.candidate,
      onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown,
      children = _ref.children;
  var r = React.useRef(null);
  React.useEffect(function () {
    if (value === candidate && r.current && r.current.offsetParent) {
      r.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
    }
  }, [candidate, value]);
  return React.createElement("li", {
    ref: r,
    value: value,
    className: className,
    onClick: onClick,
    onKeyDown: onKeyDown
  }, children);
};

var SearchInfoListCore = function SearchInfoListCore(props, ref) {
  var handler = props.handler,
      list = props.list,
      tabIndex = props.tabIndex,
      activeIndex = props.activeIndex;

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      cand = _React$useState2[0],
      setCand = _React$useState2[1];

  var arrowKeyHandler = React.useCallback(function (e) {
    if (Array.isArray(list)) {
      e.stopPropagation();
      e.keyCode !== 9 && e.preventDefault(); // don't prevent tab

      var length = list.length; // Enter 13, Spacebar 32

      if (!(length <= cand || cand < 0) && e.keyCode === 13 || e.keyCode === 32) {
        handler(list[cand], list, cand);
      } else {
        var c = length <= cand || cand < 0 ? 0 : cand; // ArrowUp 38

        if (e.keyCode === 38) {
          setCand(c === 0 ? list.length - 1 : c - 1);
        } // ArrowDown 40
        else if (e.keyCode === 40) {
            setCand(c + 1 === list.length ? 0 : c + 1);
          }
      }
    }
  }, [setCand, cand, list]);
  React.useLayoutEffect(function () {
    return setCand(0);
  }, [list]);
  return Array.isArray(list) ? React.createElement("ul", Object.assign({
    ref: ref
  }, tabIndex !== undefined ? {
    tabIndex: props.tabIndex
  } : {}, {
    className: "search-control-info-list",
    onKeyDown: arrowKeyHandler
  }), list.map(function (item, i) {
    return React.createElement(SearchInfoListItem, {
      value: i,
      candidate: cand,
      key: "".concat(item.name, "-").concat(i),
      className: "search-control-info-list-item".concat(i === activeIndex || item.checked ? " active" : "").concat(cand === i ? " candidate" : ""),
      onClick: function onClick() {
        setCand(i);
        handler(item, list, i);
      },
      onKeyDown: arrowKeyHandler
    }, item.name);
  })) : React.createElement("span", {
    className: "search-control-info-span"
  }, list);
};

SearchInfoListCore.displayName = "SearchInfoList";
var SearchInfoList = React.forwardRef(SearchInfoListCore);
export { SearchInfoList };